import useDataset from "datasets/hooks/useDataset";

/**
 * Returns whether the current user has the given permission on the active dataset,
 * as determined by the Catalog API's `actions_permitted` response.
 *
 * Defaults to `false` when the dataset has not loaded or the permission is absent.
 */
const useDatasetPermission = (permission: string): boolean => {
  const { data: dataset } = useDataset();
  return !!dataset?.actions_permitted.includes(permission);
};

export default useDatasetPermission;
